module.exports = __webpack_public_path__ + "static/media/mainimage.8d49a445.png";